(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './ktor-ktor-utils.js', './kotlin-kotlin-stdlib.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./ktor-ktor-utils.js'), require('./kotlin-kotlin-stdlib.js'));
  else {
    if (typeof this['ktor-ktor-utils'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-events'. Its dependency 'ktor-ktor-utils' was not found. Please, check whether 'ktor-ktor-utils' is loaded prior to 'ktor-ktor-events'.");
    }
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-events'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'ktor-ktor-events'.");
    }
    root['ktor-ktor-events'] = factory(typeof this['ktor-ktor-events'] === 'undefined' ? {} : this['ktor-ktor-events'], this['ktor-ktor-utils'], this['kotlin-kotlin-stdlib']);
  }
}(globalThis, function (_, kotlin_io_ktor_ktor_utils, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var LockFreeLinkedListNode = kotlin_io_ktor_ktor_utils.$_$.f;
  var initMetadataForClass = kotlin_kotlin.$_$.ha;
  var VOID = kotlin_kotlin.$_$.g;
  var CopyOnWriteHashMap = kotlin_io_ktor_ktor_utils.$_$.d;
  var THROW_CCE = kotlin_kotlin.$_$.oe;
  var equals = kotlin_kotlin.$_$.z9;
  var addSuppressed = kotlin_kotlin.$_$.af;
  var Unit_instance = kotlin_kotlin.$_$.d5;
  var protoOf = kotlin_kotlin.$_$.hb;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(HandlerRegistration, 'HandlerRegistration', VOID, LockFreeLinkedListNode);
  initMetadataForClass(Events, 'Events', Events);
  initMetadataForClass(EventDefinition, 'EventDefinition', EventDefinition);
  //endregion
  function HandlerRegistration() {
  }
  function Events() {
    this.i3o_1 = new CopyOnWriteHashMap();
  }
  protoOf(Events).j3o = function (definition, value) {
    var exception = null;
    var tmp0_safe_receiver = this.i3o_1.d39(definition);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'io.ktor.util.internal.LockFreeLinkedListHead.forEach' call
      var tmp = tmp0_safe_receiver.jx();
      var cur = tmp instanceof LockFreeLinkedListNode ? tmp : THROW_CCE();
      while (!equals(cur, tmp0_safe_receiver)) {
        if (cur instanceof HandlerRegistration) {
          // Inline function 'io.ktor.events.Events.raise.<anonymous>' call
          var registration = cur;
          try {
            var tmp_0 = registration.l3o_1;
            (typeof tmp_0 === 'function' ? tmp_0 : THROW_CCE())(value);
          } catch ($p) {
            if ($p instanceof Error) {
              var e = $p;
              var tmp0_safe_receiver_0 = exception;
              var tmp_1;
              if (tmp0_safe_receiver_0 == null) {
                tmp_1 = null;
              } else {
                addSuppressed(tmp0_safe_receiver_0, e);
                tmp_1 = Unit_instance;
              }
              if (tmp_1 == null) {
                // Inline function 'kotlin.run' call
                // Inline function 'kotlin.contracts.contract' call
                exception = e;
              }
            } else {
              throw $p;
            }
          }
        }
        cur = cur.y39();
      }
    }
    var tmp1_safe_receiver = exception;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      throw tmp1_safe_receiver;
    }
  };
  function EventDefinition() {
  }
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = EventDefinition;
  _.$_$.b = Events;
  //endregion
  return _;
}));
